<template>
    <div class="x-format-price"
         :class="{'size-sm': size === 'sm', 'size-md': size === 'md'}"
         :style="{'width': width}"
         @click="$emit('click')">
        <div class="label">{{ label }}</div>
        <div class="information">
            <div class="currency-type-symbol"><span v-if="currencyTypeSymbol">{{ currencyTypeSymbol }}</span></div>
            <div class="price">{{ format_price }}</div>
        </div>
    </div>
</template>
<script>

import numeral from "numeral";

export default {
    name: 'XFormatPrice',
    props: {
        label: {},
        price: {},
        currencyTypeSymbol: {
            default: null
        },
        width: {
            type: String,
            default: '100%'
        },
        size: {
            type: String,
            default: 'sm'
        },
        decimal: {
            default: 2
        }
    },
    computed: {
        format_price: {
            get() {
                return numeral(this.price).format('0.' + _.repeat('0', this.decimal));
            }
        },
    }
}
</script>
